import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ReferralInfo } from './types';

export type ReferrerState = {
  claimableAmount: string;
  userReferrals: {
    data: ReferralInfo[];
    hasNext: boolean;
    total: number | null;
  };
};

const initialReferrerState: ReferrerState = {
  claimableAmount: '0',
  userReferrals: {
    data: [],
    hasNext: true,
    total: null,
  },
};

const referrerSlice = createSlice({
  name: 'referrer',
  initialState: initialReferrerState,
  reducers: {
    updateReferrerState: (state: ReferrerState, action: PayloadAction<Partial<ReferrerState>>) => ({
      ...state,
      ...action.payload,
    }),

    setUserReferralsLength: (state: ReferrerState, action: PayloadAction<number>) => {
      state.userReferrals.total = action.payload;
    },

    updateClaimableAmount: (state, action: PayloadAction<ReferrerState['claimableAmount']>) => {
      state.claimableAmount = action.payload;
    },

    updateUserReferrals: (
      state: ReferrerState,
      action: PayloadAction<Omit<ReferrerState['userReferrals'], 'total'>>,
    ) => {
      const { hasNext, data } = action.payload;

      state.userReferrals.data.push(...data);
      state.userReferrals.hasNext = hasNext;
    },

    clearReferrerState: () => ({
      ...initialReferrerState,
    }),
  },
});

export const { reducer } = referrerSlice;
export const { actions } = referrerSlice;
